import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import de from './locales/de.json';
import enApp from './locales/en.app.json';
import deApp from './locales/de.app.json';

const mergeLocales = (base: Record<string, string>, extra: Record<string, string>) => ({
  ...base,
  ...extra,
});

// Read saved language BEFORE init so it's applied from the start
const savedLang = localStorage.getItem('i18nextLng');
const initialLng: string = savedLang === 'en' || savedLang === 'de' ? savedLang : 'de';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: mergeLocales(en, enApp) },
      de: { translation: mergeLocales(de, deApp) },
    },
    lng: initialLng,
    fallbackLng: 'de',
    supportedLngs: ['en', 'de'],
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false,
  });

export default i18n;
